(function() {
  'use strict';

  function normalizeLocale(rawLocale) {
    if (!rawLocale) {
      return 'en-GB';
    }

    const locale = String(rawLocale).trim();
    if (locale.toLowerCase().startsWith('fr')) {
      return 'fr-CA';
    }

    return 'en-GB';
  }

  function detectLocaleFromPath() {
    // Primary: read the <base href> Angular i18n sets per locale (e.g. /fr-CA/)
    var base = document.querySelector('base');
    var baseHref = base ? base.getAttribute('href') : null;
    if (baseHref) {
      var baseMatch = baseHref.match(/\/(fr-CA|en-GB)\//i);
      if (baseMatch) { return baseMatch[1]; }
    }
    // Fallback: check URL path
    var pathMatch = window.location.pathname.match(/^\/(fr-CA|en-GB)\//i);
    return pathMatch ? pathMatch[1] : null;
  }

  function config($translateProvider) {
    const angularLocale = window.kzAngularLocale || null;
    const configLocale = window.kzConfig ? window.kzConfig.locale : null;
    const storageLocale = window.localStorage ? window.localStorage.getItem('kzLocale') : null;
    const pathLocale = detectLocaleFromPath();
    // Prefer the locale Angular was compiled with (LOCALE_ID / $localize) so the
    // legacy layer follows the Angular 2 build, e.g. `ng serve --configuration=fr-CA`.
    const preferredLocale = normalizeLocale(
      angularLocale || storageLocale || configLocale || pathLocale
    );

    $translateProvider.useStaticFilesLoader({
      prefix: 'assets/i18n/',
      suffix: '.json'
    });

    $translateProvider.preferredLanguage(preferredLocale);
    $translateProvider.fallbackLanguage('en-GB');
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
  }

  config.$inject = ['$translateProvider'];

  angular
    .module('epf.core')
    .config(config);
})();
